import {afterRenderEffect, Directive, ElementRef, inject, input} from '@angular/core';
import {scrollTil} from "web-ng2/delt/dom/scrollIntoView";

/**
 * Scroller (uten animasjon) nærmeste scrollbare forelder slik at elementet direktivet anvendes på blir synlig, hver gang angitt verdi blir sann.
 * Gjør ingenting dersom elementet allerede er synlig (block: 'nearest').
 *
 * Med scrollTilSynligVedEndringAv scrolles det på nytt hver gang angitt verdi endres så lenge scrollTilSynlig er sann,
 * f.eks. når innhold over elementet lastes inn etter at elementet ble synlig, og elementet dermed skyves ut av synsfeltet.
 *
 * Scrollingen skjer etter at siden er tegnet ut (afterRenderEffect), slik at layout-endringer som følger av samme endring
 * (f.eks. at en liste går fra full bredde til splittvisning) er på plass.
 *
 * Merk at elementet må ha en egen boks i layout, scrollIntoView har ingen effekt på elementer med display:contents.
 *
 * Bruk:
 * ```
 * <etElement [scrollTilSynlig]="erAktiv()">
 * <etElement [scrollTilSynlig]="erAktiv()" [scrollTilSynligVedEndringAv]="antallRader()">
 * ```
 */
@Directive({
    selector: '[scrollTilSynlig]',
    standalone: true
})
export class ScrollTilSynligDirektiv {
    scrollTilSynlig = input.required<boolean>();
    /** Valgfri verdi som fører til ny scrolling når den endres (og scrollTilSynlig er sann) */
    scrollTilSynligVedEndringAv = input<unknown>();

    constructor() {
        const element = inject<ElementRef<HTMLElement>>(ElementRef).nativeElement;

        afterRenderEffect(() => {
            this.scrollTilSynligVedEndringAv();
            if (this.scrollTilSynlig())
                scrollTil(element, 0, {block: 'nearest', behavior: 'instant'});
        });
    }
}
